import Agent, {
  type AgentInstances,
  type AgentParams,
  type AgentSuggestions,
} from '../Agent';

// ResearchAgent provides research strategy and delegation capabilities, adapted from Research::LeadAgent
class ResearchAgent extends Agent {
  static name = 'Research::LeadAgent';

  static publicName = 'Research';

  static available(
    _agentParams: AgentParams,
    _agentInstances: AgentInstances
  ): boolean {
    // TODO: Deep research hasn't been fully implemented yet, so we return false for now.
    // see https://big.aha.io/features/A-18202
    return false;
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'Analyze',
        prompt:
          'Tell me what information you want to assess. You can add example text, websites, and even refer to existing Aha! records by their ID.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to analyze information.\n\nBefore starting though determine if I have provided the information to analyze. If not, ask. And before starting determine if I have provided the type of analysis I want you to conduct. If not, ask. Let's start...\n\nThe information is: `,
        icon: 'summarize',
      },
      {
        title: 'Explore',
        prompt: 'Tell me what experiments or simulations you want to run.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to help me run an experiment or simulation.\n\nBefore starting though determine if I have explained the experiment or simulation in details. If not, ask. And before starting determine if I have provided the type of report I want you to generate after you run the experiment or simulation. If not, ask. Let's start...\n\nThe experiment or simulation is: `,
        icon: 'refine',
      },
      {
        title: 'Report',
        prompt:
          'Tell me what background, market, or competitive guide you want to create.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a report.\n\nBefore starting though determine if I have provided the type of background, market, or competitive report I want you to create in detail. If not, ask. Let's start...\n\nThe report is: `,
        icon: 'list',
      },
      {
        title: 'Recognize',
        prompt:
          'Tell me what objects, people, behaviors, or actions you want to identify in a set of information.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to identify information.\n\nBefore starting though determine if I have explained the types of information I want you to identify. For example you should know if I want you to identify objects, people, behaviors, or actions in the information. If not, ask. Let's start...\n\nThe information is: `,
        icon: 'whiteboard',
      },
      {
        title: 'Predict',
        prompt:
          'Tell me what information you want to sift through to uncover patterns and possible future events.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to provide information and ask you to predict what will happen in the future.\n\nBefore starting though determine if I have explained the type of prediction I want you to make. If not, ask. And before starting determine if I have specified the timeframe for the prediction.  If not, ask. Let's start...\n\nThe information is: `,
        icon: 'draft',
      },
    ];
  }
}

Agent.register(ResearchAgent);

export default ResearchAgent;
